module.exports = "/assets/6be76b5267efacd8b495ee661739dd69.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/4A.png
// module id = 1028
// module chunks = 0